export default __webpack_public_path__ + "static/media/non-veg.d298a218.png";